import Icon_Point from "../../../assets/png/Engine_Bullet.jpg";
const NZPetrolFeatures = () => {
    return (
        <div className="bg-white pt-[60px] pb-[60px]">
            <div className="custom-container px-[30px] text-start mx-auto ">
                <div className="max-w-[1200px]  mx-auto">
                    <h2 className="kuunari-bold text-[30px] leading-[71px] text-center ">Key Features of the 2025 Tuatara EFI</h2>
                    {/* <div className="text-[20px] leading-[50px] text-center mb-[20px]">FEATURES</div> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        <div>
                            <ul className="list-none p-0 m-0">
                                {[
                                    "Tyres – range of tyre options from high grip to turf.",
                                    "Air intake snorkel.",
                                    "LED headlamps, fog lights, and an amazingly powerful roof-mounted LED light bar.",
                                    "Waterproof radio and speakers with Bluetooth.",
                                    "Electric winch with pulling capacity of  2000Kgs.",
                                    "Towing  capacity of 1000Kgs.",
                                    "Maximum ungoverned speed of 70kph.",
                                    "Selectable 2WD or 4WD.",
                                    "Selectable front or rear differential lock (or both simultaneously).",
                                    "Manually operated brake pedal lock for enhanced retention on steep inclines.",
                                    "Tilt-adjustable steering column.",
                                    "Four oversized hydraulic disc brakes with vacuum booster.",
                                    "Flatbed rear cargo  tray with 550kg. carrying capacity.",

                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-2 text-xl text-[#666666] leading-7 mb-5 font-[Montserrat] sm:text-lg flex-wrap">
                                        <span className="shrink-0">
                                            <img src={Icon_Point} className="w-5 h-5 mt-1" alt="icon" />
                                        </span>
                                        <span className="flex-1">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <ul className="list-none p-0 m-0">
                                {[
                                    "D-ring tie-downs (front & rear cargo trays).",
                                    "Generous rear cargo tray with two tool cabinets and fold-down sides.",
                                    // "Front cargo tray with 150kg. carrying capacity.",
                                    "Electric cabin operated cargo tray tip function.",
                                    // "Roof mounted LED light bar.",
                                    "PVC roof with carrying tray.",
                                    "Independent seats (3) with retractable sash type seat  belts.",
                                    "Walk through cabin design.",
                                    "Multi dashboard instrument panel (odometer, tachometer, temp. indicator).",
                                    "1 x 12V DC outlet and  dual USB connector for cell phone or other accessory charging.",
                                    "Adjustable rear drawbar with tow ball.",
                                    "Electric assisted power steering.",
                                    "Electrophoresis anti-corrosion treatment and undersealed cargo decks."
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-2 text-xl text-[#666666] leading-7 mb-5 font-[Montserrat] sm:text-lg flex-wrap">
                                        <span className="shrink-0">
                                            <img src={Icon_Point} className="w-5 h-5 mt-1" alt="icon" />
                                        </span>
                                        <span className="flex-1">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};
export default NZPetrolFeatures;
